const PLAYER_EVENTS = {
  READY: 'READY',
  FINISH: 'FINISH'
};

export default PLAYER_EVENTS;
